import '../global.css';

const FooterSection = () => (
    <section className='footer-section'>
       <img src='/ap-logo.png' alt='Abraham & Pilar logo' />
    </section>
);

export default FooterSection; 